import type { FeedbackMessages } from '../models'

import { LocaleEnum } from '../enums'

const FEEDBACK_MESSAGES_EN: FeedbackMessages = {
  header: 'Help us improve',
  questions: {
    1: 'How do you feel about the Playboard?',
  },
  textLabel: 'Tell us why',
  textPlaceholder: 'Write here your thoughts',
  checkboxLabel: 'Don’t show again',
  cancel: 'Cancel',
  submit: 'Submit',
  success: 'Thank you for the feedback!',
}

const FEEDBACK_MESSAGES_ES: FeedbackMessages = {
  header: '',
  questions: {
    1: '',
  },
  textLabel: '',
  textPlaceholder: '',
  checkboxLabel: '',
  cancel: '',
  submit: '',
  success: '',
}

export const FEEDBACK_MESSAGES: Record<string, { feedback: FeedbackMessages }> = {
  [LocaleEnum.ENGLISH]: {
    feedback: FEEDBACK_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    feedback: FEEDBACK_MESSAGES_ES,
  },
}
